import React from 'react';
import './index.module.less';

export type TPhonePanelItem = {
  name: string,
  phone: string,
  isAdmin?: boolean,
}

interface IPhonePanelProps {
  data: TPhonePanelItem[];
  onClick?: (item: TPhonePanelItem, index?: number) => void;
  showPrefix?: boolean,
}

const PhonePanel = (props: IPhonePanelProps) => {
  const { data, onClick, showPrefix = false } = props;


  const handleClick = (item: TPhonePanelItem, index: number) => {
    onClick && onClick(item, index);
  }


  const renderRowInfo = (item: TPhonePanelItem, index: number) => {
    return (
      <div styleName="row" key={index}>

        { showPrefix && <div styleName="prefix">{`按键 ${index + 1}`}</div> }
        
        <div styleName="content" onClick={() => handleClick(item, index)}>
          <div styleName="info">
            <div styleName="flex-box">
              <div styleName="name">{item.name}</div>
              { item.isAdmin && <div styleName="tag">管理员</div> }
            </div>
            <div styleName="phone">{item.phone.replace(item.phone.substring(3, 7), '****')}</div>
          </div>
          <i styleName='icon-arrow' className="iconfont icon-tubiaoyanse"/> 
        </div>
      </div>
    )
  }

  const renderRowAdd = (item: TPhonePanelItem, index: number) => {
    return (
      <div styleName="row" key={index}>

        { showPrefix && <div styleName="prefix">{`按键 ${index + 1}`}</div> }

        <div styleName="content" onClick={() => handleClick(item, index)}>
            <div styleName="add-btn"><div styleName="icon-add"></div>添加联系人</div>
        </div>
      </div>
    )
  }
 

  const renderRow = (item: TPhonePanelItem, index: number) => {
    return item.phone ? renderRowInfo(item, index) : renderRowAdd(item, index);
  }

  return (
    <div styleName="container">
      {
        data.map((item, index) => {
          return renderRow(item, index)
        })
      }
    </div>
  )
}

export default PhonePanel;
